const id_trans_itemmove = {
    "": "perpindahan barang",

    label: {
        goods_t: "jumlah barang",
        delivery_dest: "tujuan pengiriman",
        qty_t: "total kuantitas",
    },

    error: {
        create: "Gagal melakukan perpindahan barang",
        edit: "Gagal mengubah perpindahan barang",
    },

    success: {
        create: "Berhasil melakukan perpindahan barang",
        edit: "Berhasil mengubah perpindahan barang",
    },
}

export default id_trans_itemmove;